import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux'
import {
    AttributeAutoComplete,
    BrandAutoComplete,
    Head,
} from "../../../components";
import {Box, Paper} from "@mui/material";
import Container from "@mui/material/Container";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import Divider from "@mui/material/Divider";
import AccordionActions from "@mui/material/AccordionActions";
import Button from "@mui/material/Button";
import {useParams} from "react-router-dom";
import Api from "../../../utils/api";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import {Loading} from './../../../components'
import ReactPaginate from "react-paginate";

const ProductCategoryHasAssignable = (props) => {
    
    const { id, title } = useParams();
    

    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState({});
    const [category, setCategory] = useState(null);
    const [list, setList] = useState([]);
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(true);

    const _title = {
        brands : 'برندها',
        attributes : 'ویژگی ها',
        filters : 'فیلترهای دلخواه',
    }

    useEffect(() => {
        handleRequest();
    }, [page, filter]);

    useEffect(() => {
        new Api().get('/products/categories/' + id).then((response) => {
            if (typeof response !== "undefined") {
                setCategory(response);
            }
        })
    }, []);


    const handleRequest = () => {

        setLoading(true);

        switch (title) {
            case 'brands':

                new Api().get('/products/categories/' + id + '/brands/selected').then((response) => {
                    if (typeof response !== "undefined") {
                        setSelected(response);
                        setLoading(false);
                    }
                });

                new Api().get('/products/categories/' + id + '/brands', filter).then((response) => { // get all with checked
                    if (typeof response !== "undefined") {
                        setList(response);
                        setLoading(false);
                    }
                });

                break;
            case 'attributes':
                new Api().get('/products/categories/' + id + '/attributes/selected').then((response) => {
                    if (typeof response !== "undefined") {
                        setSelected(response);
                        setLoading(false);
                    }
                });

                new Api().get('/products/categories/' + id + '/attributes', filter).then((response) => { // get all with checked
                    if (typeof response !== "undefined") {
                        setList(response);
                        setLoading(false);
                    }
                });


                break;
            case 'filters':
                new Api().get('/products/categories/' + id + '/filters/selected').then((response) => {
                    if (typeof response !== "undefined") {
                        setSelected(response);
                        setLoading(false);
                    }
                });

                new Api().get('/products/categories/' + id + '/filters').then((response) => { // get all with checked
                    if (typeof response !== "undefined") {
                        setList(response);
                        setLoading(false);
                    }
                });

                break;

        }
    };

    const handleDelete = (id) => {
        switch (title) {
            case 'brands':
                new Api().delete('/products/categories/' + id + '/brands/selected', {id: id}).then((response) => {
                    if (typeof response !== "undefined") {
                        handleRequest();
                    }
                });
                break;
            case 'attributes':
                new Api().delete('/products/categories/' + id + '/attributes/selected', {id: id}).then((response) => {
                    if (typeof response !== "undefined") {
                        handleRequest();
                    }
                });
                break;
            case 'filters':
                new Api().delete('/products/categories/' + id + '/filters/selected', {id: id}).then((response) => {
                    if (typeof response !== "undefined") {
                        handleRequest();
                    }
                });
                break;

        }
    }


    const handleStore = (event, id) => {
        switch (title) {
            case 'brands':
                if (event.target.checked === true) {
                    new Api().post('/products/categories/' + id + '/brands', {id: id}).then((response) => {
                        if (typeof response !== "undefined") {
                            handleRequest();
                        }
                    });
                } else {
                    handleDelete(id);
                }
                break;
            case 'attributes':
                if (event.target.checked === true) {
                    new Api().post('/products/categories/' + id + '/attributes', {id: id}).then((response) => {
                        if (typeof response !== "undefined") {
                            handleRequest();
                        }
                    });
                } else {
                    handleDelete(id);
                }
                break;
            case 'filters':

                if (event.target.checked === true) {
                    new Api().post('/products/categories/' + id + '/filters', {id: id}).then((response) => {
                        if (typeof response !== "undefined") {
                            handleRequest();
                        }
                    });
                } else {
                    handleDelete(id);
                }
                break;

        }
    }


    const handleChangeElementWithAutoComplete = (name, value) => {
        let frm = {...filter};
        if (value) {
            frm['id'] = value.id;
            frm['title'] = value.title;

        } else {
            frm['id'] = '';
            frm['title'] = '';
        }
        setFilter(frm);
    };



    return(
        <Container>
            <Head data={{ 'link': '/product/category', 'title': _title[title] + ' در ' + (category ? category.title : '') , 'description': 'فیلتر های صفحه فروشگاه را تعیین کنید' }} />
            {title !== 'filters' && <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography >جستجو</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            {title === 'brands' && <Grid xs={12} sm={4}>
                                <BrandAutoComplete onChange={(value) => handleChangeElementWithAutoComplete('id', value)}/>
                            </Grid>}
                            {title === 'attributes' && <Grid xs={12} sm={4}>
                                <AttributeAutoComplete onChange={(value) => handleChangeElementWithAutoComplete('id', value)}/>
                            </Grid>}
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>}
            <Box className='display-flex display-flex-justify-content-center'>
                {selected && selected.map((chip, index) => {
                    return(
                        <Chip key={index} onDelete={() => handleDelete(chip.id)} label={chip.title} />
                    );
                })}
            </Box>
            <Box mt={5}>
                <Paper elevation={1} style={{ padding: '15px'}}>
                    <Grid container>
                        {list.data && list.data.map((item, index) => {
                            return(
                                <Grid key={index} item xs={12} sm={3}>
                                    <FormControlLabel key={index} control={
                                        <Checkbox
                                            checked={+item.status}
                                            value={+item.id}
                                            onChange={(event) => handleStore(event,item.id)}
                                        />
                                    } label={item.title ? item.title : item.id} />
                                </Grid>
                            );
                        })}
                    </Grid>
                    {loading && <Loading/>}
                </Paper>
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={list.total}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                    containerClassName={'pagination'}
                    activeClassName={'active'}
                />

            </Box>
        </Container>

    );
}


const mapStateToProps = state => ({
    authReducer: state.authReducer
});


export default connect(mapStateToProps)(ProductCategoryHasAssignable)
